/**
 * WEB: o nível 1 do aviso de sincronização (≥ 30 min) é um PUSH na tela — no app nativo é
 * a notificação local. O "Sincronizar agora" roda dentro do próprio push: ele vira
 * "Sincronizando…" e depois mostra o resultado (com "Tentar de novo" se sobrou algo).
 */
import { push } from "@/components/push/push";
import { sincronizarAgora, type SituacaoAvisoSync } from "@/services/AvisoSync";
import { mensagemResultadoSync, textoAtrasoSync } from "@/utils/avisoSync";

const CHAVE = "aviso-sync";

async function sincronizarNoPush(id: string): Promise<void> {
  push.atualizar(id, {
    carregando: true,
    tom: "info",
    titulo: "Sincronizando...",
    mensagem: "Enviando os registros guardados neste aparelho.",
    acoes: [],
    duracaoMs: null,
  });
  const r = await sincronizarAgora();
  const m = mensagemResultadoSync(r);
  // Fechado durante o envio: o resultado sai num push novo.
  const alvo = push.existe(id) ? id : push.mostrar({ titulo: m.titulo, chave: CHAVE });
  push.atualizar(alvo, {
    carregando: false,
    tom: m.ok ? "sucesso" : "alerta",
    icone: m.ok ? "cloud-check-outline" : r.semInternet ? "wifi-off" : "cloud-alert",
    titulo: m.titulo,
    mensagem: m.texto,
    duracaoMs: m.ok ? 5000 : 12000,
    acoes: m.ok
      ? []
      : [
          {
            rotulo: "Tentar de novo",
            principal: true,
            manterAberto: true,
            aoTocar: () => void sincronizarNoPush(alvo),
          },
        ],
  });
}

/** Push do nível 1: "Itens aguardando sincronização" + "Sincronizar agora". */
export function mostrarPushAvisoSync(s: SituacaoAvisoSync): void {
  const total = s.total;
  const id = push.mostrar({
    chave: CHAVE,
    tom: "info",
    icone: "cloud-upload-outline",
    titulo: "Itens aguardando sincronização",
    mensagem: `${total} ${total === 1 ? "registro guardado" : "registros guardados"} neste aparelho ${textoAtrasoSync(s.idadeMs)}.`,
    duracaoMs: 15000,
    acoes: [
      { rotulo: "Depois" },
      {
        rotulo: "Sincronizar agora",
        principal: true,
        manterAberto: true,
        aoTocar: () => void sincronizarNoPush(id),
      },
    ],
  });
}

/** Clique na notificação do sistema: sincroniza mostrando o andamento num push. */
export function sincronizarComPush(): void {
  const id = push.mostrar({ chave: CHAVE, titulo: "Sincronizando...", carregando: true, duracaoMs: null });
  void sincronizarNoPush(id);
}
